import { apiClient } from "./apiClient";
import { unwrapApiResponse } from "../shared/utils/apiResponse";

export type AttachmentItem = {
  id: string;
  attachmentType: string;
  fileName: string;
  contentType: string;
  fileSize: number;
  uploadedAt: string;
  downloadUrl?: string;
  previewUrl?: string;
};

export async function listAttachments(module: string, entityId: string | number) {
  const { data } = await apiClient.get(`/attachments/${module}/${entityId}`);
  const rows = unwrapApiResponse<AttachmentItem[]>(data);
  return Array.isArray(rows) ? rows : [];
}

export async function uploadAttachment(args: {
  module: string;
  entityId?: string | number | null;
  tempKey?: string | null;
  attachmentType: "bill" | "voucher" | "employee-document";
  category?: "pan-card" | "voter-id" | "aadhaar-card" | "bank-passbook";
  file: File;
  onProgress?: (percent: number) => void;
}) {
  const form = new FormData();
  form.append("Module", args.module);
  form.append("EntityId", String(args.entityId ?? 0));
  form.append("AttachmentType", args.attachmentType);
  if (args.category) form.append("Category", args.category);
  if (args.tempKey) form.append("TempKey", args.tempKey);
  form.append("File", args.file);
  const { data } = await apiClient.post("/attachments/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (event) => {
      if (!args.onProgress || !event.total) return;
      args.onProgress(Math.round((event.loaded / event.total) * 100));
    }
  });
  return unwrapApiResponse<string>(data);
}

export async function deleteAttachment(id: string) {
  const { data } = await apiClient.delete(`/attachments/${id}`);
  return data;
}

export async function cleanupTempAttachments(tempKeys: string[]) {
  if (!tempKeys.length) return true;
  const { data } = await apiClient.post("/attachments/cleanup-temp", tempKeys);
  return data;
}
